import { Clients_Data } from "./index";

const useIdentifySsoClient = (companyNumber) => {
  const getClientData = () => {
    const client = Clients_Data.find(
      (client) => client.compNumber === companyNumber
    );
    return client
      ? {
          compNumber: client.compNumber,
          compName: client.compName,
          ssoUatUrl: client.ssoUatUrl,
          ssoProdUrl: client.ssoProdUrl,
          isSsoClient: client.isSsoClient,
        }
      : null;
  };

  return getClientData();
};

export default useIdentifySsoClient;
